import { createSlice, type PayloadAction } from '@reduxjs/toolkit';
import {
  DEFAULT_APPEARANCE,
  clearAppearance,
  readAppearance,
  writeAppearance,
  type Appearance,
} from '@/lib/theme';

/**
 * The colours this device shows the system in.
 *
 * Held in the store so every screen repaints the moment it changes, and
 * written to local storage on the way through so it survives a reload. It is
 * never sent to the server: it belongs to the person at this screen, not to
 * the business.
 */
const appearanceSlice = createSlice({
  name: 'appearance',
  initialState: readAppearance(),
  reducers: {
    appearanceChanged(_state, action: PayloadAction<Appearance>) {
      writeAppearance(action.payload);
      return action.payload;
    },
    appearanceReset() {
      clearAppearance();
      return DEFAULT_APPEARANCE;
    },
  },
});

export const { appearanceChanged, appearanceReset } = appearanceSlice.actions;
export default appearanceSlice.reducer;
